
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms/letter",
      function () {
        return require("private-next-pages/forms/letter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forms/letter"])
      });
    }
  